// purchaseOrderItemKeys.js
//
// Shared PURCHASE_ORDER / PURCHASE_ORDER_ITEM type keys and helpers.

export const PURCHASE_ORDER_TYPE_KEY = 'PURCHASE_ORDER';
export const PURCHASE_ORDER_ITEM_TYPE_KEY = 'PURCHASE_ORDER_ITEM';

function normalizeTypeKey(value) {
  return String(value || '').trim().toUpperCase();
}

/**
 * @param {object|null|undefined} node
 * @returns {boolean}
 */
export function isPurchaseOrderNode(node) {
  return normalizeTypeKey(node?.type) === PURCHASE_ORDER_TYPE_KEY;
}

/**
 * @param {unknown} typeKey
 * @returns {boolean}
 */
export function isPurchaseOrderItemTypeKey(typeKey) {
  return normalizeTypeKey(typeKey) === PURCHASE_ORDER_ITEM_TYPE_KEY;
}
